module.exports = __webpack_public_path__ + "static/media/windy.svg.8eac426d.png";